import { render, staticRenderFns } from "./SignUpPopUp.vue?vue&type=template&id=4eedc051&scoped=true"
import script from "./SignUpPopUp.vue?vue&type=script&lang=js"
export * from "./SignUpPopUp.vue?vue&type=script&lang=js"
import style0 from "./SignUpPopUp.vue?vue&type=style&index=0&id=4eedc051&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eedc051",
  null
  
)

export default component.exports